module.exports = __webpack_public_path__ + "img/bg_main_top_n_mobile.e884d4ed.png";